import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M23.7296 12.1907C24.0901 11.8002 24.0901 11.167 23.7296 10.7765L17.8552 4.41252C17.4947 4.022 16.9103 4.022 16.5498 4.41252C16.1893 4.80305 16.1893 5.43621 16.5498 5.82673L21.7715 11.4836L16.5498 17.1405C16.1893 17.531 16.1893 18.1641 16.5498 18.5547C16.9103 18.9452 17.4947 18.9452 17.8552 18.5547L23.7296 12.1907ZM0 12.4836H23.0769V10.4836H0V12.4836Z" fill="black"/>
</svg>
;
